import React from 'react'
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { observer } from "mobx-react";

type RatingBlockV3Props = {
    productCard: ShowableProductCard
}

const RatingBlockV3 = observer((props: RatingBlockV3Props) => {
    const svg: JSX.Element[] = [];
    if (props.productCard.rating !== null) {
        for (let i = 0; i < props.productCard.rating.numberStars; i++) {
            svg.push(<svg key={i} className="rating-star-v3__icon" width="14" height="11">
                <use xlinkHref="/build/sprite.svg#starV2"></use>
            </svg>);
        }
    }

    return (
        <div className="rating-star-v3">
            {svg}
        </div>
    );

})

export default RatingBlockV3;